/**
 * Task 225 — the lazy boundary for Caminos de Luz.
 *
 * This is the ONLY caminos file App.tsx imports. The 3D scene loads via dynamic
 * import() — and because CaminosView and ConnectionsView import the SAME
 * 3d-force-graph/three modules, the bundler emits ONE shared chunk for them
 * (no second copy of three; verified in the vite output). Nothing outside the
 * lazy chunks may import 3d-force-graph (three.js breaks under node — hermetic
 * smokes must never touch it).
 */
import { Suspense, lazy, type JSX } from "react";
import type { CorpusRoute } from "../corpus/use-corpus-route";
import type { Language } from "../strings";
import type { Strings } from "../strings/types";

const CaminosView = lazy(() => import("./CaminosView"));

export interface CaminosRouteProps {
  route: CorpusRoute;
  navigate: (to: string) => void;
  language: Language;
  onLanguage: (lang: Language) => void;
  strings: Strings;
  onAsk: (prompt: string) => void;
  onAbout: () => void;
}

export function CaminosRoute(props: CaminosRouteProps): JSX.Element {
  return (
    <Suspense
      fallback={
        <div className="caminos caminos--loading">
          <p className="creader-note">{props.strings.caminosLoading}</p>
        </div>
      }
    >
      <CaminosView {...props} />
    </Suspense>
  );
}
